import { createApiHooks } from '../common';
import {
  getDiagnosticPackageUrl,
  searchDiagnosticPackages,
  retrieveDiagnosticPackage,
  getDiagnosticPackageAction,
  searchDiagnosticPackageActions
} from './api';

const {
  useSearchDiagnosticPackagesQuery,
  useSearchDiagnosticPackageActionsQuery,
  useGetDiagnosticPackageActionQuery,
  useGetDiagnosticPackageUrlMutation,
  useRetrieveDiagnosticPackageMutation
} = createApiHooks({
  name: 'dl',
  queries: {
    searchDiagnosticPackages,
    searchDiagnosticPackageActions,
    getDiagnosticPackageAction
  },
  mutations: {
    getDiagnosticPackageUrl,
    retrieveDiagnosticPackage
  }
});

export {
  useSearchDiagnosticPackagesQuery,
  useSearchDiagnosticPackageActionsQuery,
  useGetDiagnosticPackageActionQuery,
  useGetDiagnosticPackageUrlMutation,
  useRetrieveDiagnosticPackageMutation
};
